var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1306EA12-8745-4FDC-A377-0F237B6B07EC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Login-Multiple_01",
    transform: "translate(-1254.000000, -21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.Components/14.Navigation-Bar/02.Dashboard/02.Top",
    transform: "translate(220.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(981.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Notification-/-On-Copy",
    transform: "translate(41.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "menu-(3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.750121, 0.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99346462,0 L1.25622645,0 C0.563501897,0 0,0.563501897 0,1.25622645 L0,5.99346462 C0,6.68618918 0.563501897,7.24969108 1.25622645,7.24969108 L5.99346462,7.24969108 C6.68618918,7.24969108 7.24969108,6.68618918 7.24969108,5.99346462 L7.24969108,1.25622645 C7.24957996,0.563501897 6.68618918,0 5.99346462,0 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2437735,0 L10.5065354,0 C9.81381082,0 9.25030892,0.563501897 9.25030892,1.25622645 L9.25030892,5.99346462 C9.25030892,6.68618918 9.81381082,7.24969108 10.5065354,7.24969108 L15.2437735,7.24969108 C15.9364981,7.24969108 16.5,6.68618918 16.5,5.99346462 L16.5,1.25622645 C16.5,0.563501897 15.9364981,0 15.2437735,0 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99346462,9.25042004 L1.25622645,9.25042004 C0.563501897,9.25042004 0,9.81386638 0,10.5065909 L0,15.2438291 C0,15.9365537 0.563501897,16.5000556 1.25622645,16.5000556 L5.99346462,16.5000556 C6.68618918,16.5000556 7.24969108,15.9365537 7.24969108,15.2438291 L7.24969108,10.5065909 C7.24957996,9.81386638 6.68618918,9.25042004 5.99346462,9.25042004 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2437735,9.25042004 L10.5065354,9.25042004 C9.81381082,9.25042004 9.25030892,9.81392193 9.25030892,10.5066465 L9.25030892,15.2438847 C9.25030892,15.9366092 9.81381082,16.5001111 10.5065354,16.5001111 L15.2437735,16.5001111 C15.9364981,16.5001111 16.5,15.9365537 16.5,15.2438291 L16.5,10.5065909 C16.5,9.81386638 15.9364981,9.25042004 15.2437735,9.25042004 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.8db3894a863598b2fd37aafa3b63eedc.svg";
export { ForwardRef as ReactComponent };